import { GatewayApiClient } from '@ifit/gateway';
import { IfitApiClient } from '@ifit/ifit-api-v1';

let apiClient;
let gatewayClient;

function createClients(options) {
  const {
    baseGatewayAPIUrl,
    baseIfitAPIUrl,
    ifitAPIUrlVersion,
    bearerToken,
    clientId,
    clientSecret } = options;
  const version = ifitAPIUrlVersion || 'v1';
  gatewayClient = new GatewayApiClient(`${baseGatewayAPIUrl}/`, bearerToken, clientId, clientSecret);
  apiClient = new IfitApiClient(`${baseIfitAPIUrl}/${version}/`, bearerToken, clientId, clientSecret);
}

function getGatewayClient() {
  return gatewayClient;
}

function setClients(_apiClient, _gatewayClient) {
  apiClient = _apiClient;
  gatewayClient = _gatewayClient;
}

function getApiClient() {
  return apiClient;
}

function resetClients() {
  gatewayClient = undefined;
  apiClient = undefined;
}

export {
  createClients,
  getApiClient,
  getGatewayClient,
  resetClients,
  setClients
};


// WEBPACK FOOTER //
// ./src/client.js